import styled, { keyframes } from "styled-components";

import { Button } from "_/components/button";
import { palette } from "_/style";

export const Wrapper = styled.div`
  width: 100%;
  max-width: 380px;
`;

export const Title = styled.h1`
  margin: 0 0 24px;
  font-size: 1.5rem;
  font-weight: 500;
  letter-spacing: -0.01em;
  line-height: 1.2;
  color: ${(p) => p.theme.text.default};
`;

export const LoginForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 14px;
`;

export const CollapsibleField = styled.div<{ $visible: boolean }>`
  display: grid;
  grid-template-rows: ${(p) => (p.$visible ? "1fr" : "0fr")};
  opacity: ${(p) => (p.$visible ? 1 : 0)};
  transition:
    grid-template-rows 0.25s ease,
    opacity 0.2s ease;

  & > * {
    overflow: hidden;
  }
`;

const aonSpin = keyframes`
  to { transform: rotate(360deg); }
`;

export const CheckingSpinner = styled.span`
  display: inline-block;
  width: 16px;
  height: 16px;
  border: 2px solid ${(p) => p.theme.text.muted};
  border-top-color: transparent;
  border-radius: 50%;
  animation: ${aonSpin} 0.6s linear infinite;
  margin-right: 4px;
  flex-shrink: 0;
`;

export const OptionsRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 2px;
  font-size: 0.75rem;
`;

export const ForgotLink = styled.a`
  font-size: inherit;
  color: ${(p) => p.theme.text.muted};
  text-decoration: underline;
  text-decoration-color: ${(p) => p.theme.divider.large};
  text-underline-offset: 3px;
  cursor: pointer;
  transition:
    color 0.12s ease,
    text-decoration-color 0.12s ease;

  &:hover {
    color: ${(p) => p.theme.text.default};
    text-decoration-color: ${(p) => p.theme.text.muted};
  }
`;

export const ErrorLine = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: ${palette.blushRed};
  padding: 10px 12px;
  background: rgba(246, 43, 18, 0.08);
  border: 1px solid rgba(246, 43, 18, 0.25);
  border-radius: 2px;
`;

export const ErrorBadge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border-radius: 8px;
  background: ${palette.tomatoRed};
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  flex-shrink: 0;
`;

export const LoginButton = styled(Button)`
  width: 100%;
  height: 42px;
  margin-top: 4px;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.02em;
  border-radius: 2px;
`;

const basisPulse = keyframes`
  0% { opacity: 0.3; transform: scale(0.7); }
  100% { opacity: 1; transform: scale(1); }
`;

export const LoadingDots = styled.span`
  display: inline-flex;
  gap: 4px;
  align-items: center;
`;

export const Dot = styled.span<{ $delay: number }>`
  width: 6px;
  height: 6px;
  border-radius: 3px;
  background: #fff;
  animation: ${basisPulse} 1s ${(p) => p.$delay}s infinite alternate;
`;

export const Footer = styled.div`
  margin-top: 28px;
  padding-top: 20px;
  border-top: 1px solid ${(p) => p.theme.divider.large};
  font-size: 12px;
  color: ${palette.nickelGrey};
  text-align: center;
  line-height: 1.6;
`;

export const RedirectNotice = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.5rem;
  padding: 2rem 0;
`;

export const RedirectText = styled.span`
  font-size: 14px;
  color: ${(p) => p.theme.text.muted};
`;
